export const DEFAULT_DURATION = 5_000;

export const SHOW_SNACKBAR_EVENT_TYPE = 'show-snackbar';

export const HIDE_SNACKBAR_EVENT_TYPE = 'hide-snackbar';
